import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Constant} from '../../global/util/Constant';
import {Observable} from 'rxjs';
import {Headers} from '../../global/util/Headers';
import {Tsacredential} from '../model/Tsacredential';

@Injectable({
  providedIn: 'root'
})
export class TsaCredentialService {

  private url = Constant.ROOT_API_V1.concat('/tsacredentials');

  constructor(private http: HttpClient) {
  }

  public get(url: string) {
    return this.http.get(url);
  }

  public save(tsaprovider: Tsacredential): Observable<Response> {
    return this.http.post<any>(this.url, JSON.stringify(tsaprovider), Headers.contentType);
  }

  public edit(tsaprovider: Tsacredential): Observable<any> {
    return this.http.put(this.url, JSON.stringify(tsaprovider), Headers.contentType);
  }

  public delete(tsaprovider: Tsacredential) {
    const url = this.url.concat('/', String(tsaprovider.id));
    return this.http.delete(url);
  }
}
